var endpointMap = {
	ar: {
		"components.accountSwitcher": "translation-ar.json",
		"components.footer": "translation-ar.json",
		"components.header": "translation-ar.json",
		"components.pageHeader": "translation-ar.json",
		"components.pivotNav": "translation-ar.json",
		"components.sidenav": "translation-ar.json"
	},
	"ar-AE": {
		"components.accountSwitcher": "translation-ar.json",
		"components.footer": "translation-ar.json",
		"components.header": "translation-ar.json",
		"components.pageHeader": "translation-ar.json",
		"components.pivotNav": "translation-ar.json",
		"components.sidenav": "translation-ar.json"
	},
	de: {
		"components.accountSwitcher": "translation-de.json",
		"components.footer": "translation-de.json",
		"components.header": "translation-de.json",
		"components.pageHeader": "translation-de.json",
		"components.pivotNav": "translation-de.json",
		"components.sidenav": "translation-de.json"
	},
	"de-DE": {
		"components.accountSwitcher": "translation-de.json",
		"components.footer": "translation-de.json",
		"components.header": "translation-de.json",
		"components.pageHeader": "translation-de.json",
		"components.pivotNav": "translation-de.json",
		"components.sidenav": "translation-de.json"
	},
	en: {
		"components.accountSwitcher": "translation-en.json",
		"components.footer": "translation-en.json",
		"components.header": "translation-en.json",
		"components.pageHeader": "translation-en.json",
		"components.pivotNav": "translation-en.json",
		"components.sidenav": "translation-en.json"
	},
	"en-AU": {
		"components.accountSwitcher": "translation-en.json",
		"components.footer": "translation-en.json",
		"components.header": "translation-en.json",
		"components.pageHeader": "translation-en.json",
		"components.pivotNav": "translation-en.json",
		"components.sidenav": "translation-en.json"
	},
	"en-CA": {
		"components.accountSwitcher": "translation-en.json",
		"components.footer": "translation-en.json",
		"components.header": "translation-en.json",
		"components.pageHeader": "translation-en.json",
		"components.pivotNav": "translation-en.json",
		"components.sidenav": "translation-en.json"
	},
	"en-GB": {
		"components.accountSwitcher": "translation-en.json",
		"components.footer": "translation-en.json",
		"components.header": "translation-en.json",
		"components.pageHeader": "translation-en.json",
		"components.pivotNav": "translation-en.json",
		"components.sidenav": "translation-en.json"
	},
	"en-IN": {
		"components.accountSwitcher": "translation-en.json",
		"components.footer": "translation-en.json",
		"components.header": "translation-en.json",
		"components.pageHeader": "translation-en.json",
		"components.pivotNav": "translation-en.json",
		"components.sidenav": "translation-en.json"
	},
	"en-SG": {
		"components.accountSwitcher": "translation-en.json",
		"components.footer": "translation-en.json",
		"components.header": "translation-en.json",
		"components.pageHeader": "translation-en.json",
		"components.pivotNav": "translation-en.json",
		"components.sidenav": "translation-en.json"
	},
	"en-US": {
		"components.accountSwitcher": "translation-en.json",
		"components.footer": "translation-en.json",
		"components.header": "translation-en.json",
		"components.pageHeader": "translation-en.json",
		"components.pivotNav": "translation-en.json",
		"components.sidenav": "translation-en.json"
	},
	es: {
		"components.accountSwitcher": "translation-es.json",
		"components.footer": "translation-es.json",
		"components.header": "translation-es.json",
		"components.pageHeader": "translation-es.json",
		"components.pivotNav": "translation-es.json",
		"components.sidenav": "translation-es.json"
	},
	"es-CO": {
		"components.accountSwitcher": "translation-es.json",
		"components.footer": "translation-es.json",
		"components.header": "translation-es.json",
		"components.pageHeader": "translation-es.json",
		"components.pivotNav": "translation-es.json",
		"components.sidenav": "translation-es.json"
	},
	"es-ES": {
		"components.accountSwitcher": "translation-es.json",
		"components.footer": "translation-es.json",
		"components.header": "translation-es.json",
		"components.pageHeader": "translation-es.json",
		"components.pivotNav": "translation-es.json",
		"components.sidenav": "translation-es.json"
	},
	"es-MX": {
		"components.accountSwitcher": "translation-es.json",
		"components.footer": "translation-es.json",
		"components.header": "translation-es.json",
		"components.pageHeader": "translation-es.json",
		"components.pivotNav": "translation-es.json",
		"components.sidenav": "translation-es.json"
	},
	fr: {
		"components.accountSwitcher": "translation-fr.json",
		"components.footer": "translation-fr.json",
		"components.header": "translation-fr.json",
		"components.pageHeader": "translation-fr.json",
		"components.pivotNav": "translation-fr.json",
		"components.sidenav": "translation-fr.json"
	},
	"fr-CA": {
		"components.accountSwitcher": "translation-fr.json",
		"components.footer": "translation-fr.json",
		"components.header": "translation-fr.json",
		"components.pageHeader": "translation-fr.json",
		"components.pivotNav": "translation-fr.json",
		"components.sidenav": "translation-fr.json"
	},
	"fr-FR": {
		"components.accountSwitcher": "translation-fr.json",
		"components.footer": "translation-fr.json",
		"components.header": "translation-fr.json",
		"components.pageHeader": "translation-fr.json",
		"components.pivotNav": "translation-fr.json",
		"components.sidenav": "translation-fr.json"
	},
	hi: {
		"components.accountSwitcher": "translation-hi.json",
		"components.footer": "translation-hi.json",
		"components.header": "translation-hi.json",
		"components.pageHeader": "translation-hi.json",
		"components.pivotNav": "translation-hi.json",
		"components.sidenav": "translation-hi.json"
	},
	"hi-IN": {
		"components.accountSwitcher": "translation-hi.json",
		"components.footer": "translation-hi.json",
		"components.header": "translation-hi.json",
		"components.pageHeader": "translation-hi.json",
		"components.pivotNav": "translation-hi.json",
		"components.sidenav": "translation-hi.json"
	},
	it: {
		"components.accountSwitcher": "translation-it.json",
		"components.footer": "translation-it.json",
		"components.header": "translation-it.json",
		"components.pageHeader": "translation-it.json",
		"components.pivotNav": "translation-it.json",
		"components.sidenav": "translation-it.json"
	},
	"it-IT": {
		"components.accountSwitcher": "translation-it.json",
		"components.footer": "translation-it.json",
		"components.header": "translation-it.json",
		"components.pageHeader": "translation-it.json",
		"components.pivotNav": "translation-it.json",
		"components.sidenav": "translation-it.json"
	},
	ja: {
		"components.accountSwitcher": "translation-ja.json",
		"components.footer": "translation-ja.json",
		"components.header": "translation-ja.json",
		"components.pageHeader": "translation-ja.json",
		"components.pivotNav": "translation-ja.json",
		"components.sidenav": "translation-ja.json"
	},
	"ja-JP": {
		"components.accountSwitcher": "translation-ja.json",
		"components.footer": "translation-ja.json",
		"components.header": "translation-ja.json",
		"components.pageHeader": "translation-ja.json",
		"components.pivotNav": "translation-ja.json",
		"components.sidenav": "translation-ja.json"
	},
	ko: {
		"components.accountSwitcher": "translation-ko.json",
		"components.footer": "translation-ko.json",
		"components.header": "translation-ko.json",
		"components.pageHeader": "translation-ko.json",
		"components.pivotNav": "translation-ko.json",
		"components.sidenav": "translation-ko.json"
	},
	"ko-KR": {
		"components.accountSwitcher": "translation-ko.json",
		"components.footer": "translation-ko.json",
		"components.header": "translation-ko.json",
		"components.pageHeader": "translation-ko.json",
		"components.pivotNav": "translation-ko.json",
		"components.sidenav": "translation-ko.json"
	},
	nl: {
		"components.accountSwitcher": "translation-nl.json",
		"components.footer": "translation-nl.json",
		"components.header": "translation-nl.json",
		"components.pageHeader": "translation-nl.json",
		"components.pivotNav": "translation-nl.json",
		"components.sidenav": "translation-nl.json"
	},
	"nl-NL": {
		"components.accountSwitcher": "translation-nl.json",
		"components.footer": "translation-nl.json",
		"components.header": "translation-nl.json",
		"components.pageHeader": "translation-nl.json",
		"components.pivotNav": "translation-nl.json",
		"components.sidenav": "translation-nl.json"
	},
	pl: {
		"components.accountSwitcher": "translation-pl.json",
		"components.footer": "translation-pl.json",
		"components.header": "translation-pl.json",
		"components.pageHeader": "translation-pl.json",
		"components.pivotNav": "translation-pl.json",
		"components.sidenav": "translation-pl.json"
	},
	"pl-PL": {
		"components.accountSwitcher": "translation-pl.json",
		"components.footer": "translation-pl.json",
		"components.header": "translation-pl.json",
		"components.pageHeader": "translation-pl.json",
		"components.pivotNav": "translation-pl.json",
		"components.sidenav": "translation-pl.json"
	},
	pt: {
		"components.accountSwitcher": "translation-pt.json",
		"components.footer": "translation-pt.json",
		"components.header": "translation-pt.json",
		"components.pageHeader": "translation-pt.json",
		"components.pivotNav": "translation-pt.json",
		"components.sidenav": "translation-pt.json"
	},
	"pt-BR": {
		"components.accountSwitcher": "translation-pt.json",
		"components.footer": "translation-pt.json",
		"components.header": "translation-pt.json",
		"components.pageHeader": "translation-pt.json",
		"components.pivotNav": "translation-pt.json",
		"components.sidenav": "translation-pt.json"
	},
	sv: {
		"components.accountSwitcher": "translation-sv.json",
		"components.footer": "translation-sv.json",
		"components.header": "translation-sv.json",
		"components.pageHeader": "translation-sv.json",
		"components.pivotNav": "translation-sv.json",
		"components.sidenav": "translation-sv.json"
	},
	"sv-SE": {
		"components.accountSwitcher": "translation-sv.json",
		"components.footer": "translation-sv.json",
		"components.header": "translation-sv.json",
		"components.pageHeader": "translation-sv.json",
		"components.pivotNav": "translation-sv.json",
		"components.sidenav": "translation-sv.json"
	},
	ta: {
		"components.accountSwitcher": "translation-ta.json",
		"components.footer": "translation-ta.json",
		"components.header": "translation-ta.json",
		"components.pageHeader": "translation-ta.json",
		"components.pivotNav": "translation-ta.json",
		"components.sidenav": "translation-ta.json"
	},
	"ta-IN": {
		"components.accountSwitcher": "translation-ta.json",
		"components.footer": "translation-ta.json",
		"components.header": "translation-ta.json",
		"components.pageHeader": "translation-ta.json",
		"components.pivotNav": "translation-ta.json",
		"components.sidenav": "translation-ta.json"
	},
	th: {
		"components.accountSwitcher": "translation-th.json",
		"components.footer": "translation-th.json",
		"components.header": "translation-th.json",
		"components.pageHeader": "translation-th.json",
		"components.pivotNav": "translation-th.json",
		"components.sidenav": "translation-th.json"
	},
	"th-TH": {
		"components.accountSwitcher": "translation-th.json",
		"components.footer": "translation-th.json",
		"components.header": "translation-th.json",
		"components.pageHeader": "translation-th.json",
		"components.pivotNav": "translation-th.json",
		"components.sidenav": "translation-th.json"
	},
	tr: {
		"components.accountSwitcher": "translation-tr.json",
		"components.footer": "translation-tr.json",
		"components.header": "translation-tr.json",
		"components.pageHeader": "translation-tr.json",
		"components.pivotNav": "translation-tr.json",
		"components.sidenav": "translation-tr.json"
	},
	"tr-TR": {
		"components.accountSwitcher": "translation-tr.json",
		"components.footer": "translation-tr.json",
		"components.header": "translation-tr.json",
		"components.pageHeader": "translation-tr.json",
		"components.pivotNav": "translation-tr.json",
		"components.sidenav": "translation-tr.json"
	},
	und: {
		"components.accountSwitcher": "translation.json",
		"components.footer": "translation.json",
		"components.header": "translation.json",
		"components.pageHeader": "translation.json",
		"components.pivotNav": "translation.json",
		"components.sidenav": "translation.json"
	},
	vi: {
		"components.accountSwitcher": "translation-vi.json",
		"components.footer": "translation-vi.json",
		"components.header": "translation-vi.json",
		"components.pageHeader": "translation-vi.json",
		"components.pivotNav": "translation-vi.json",
		"components.sidenav": "translation-vi.json"
	},
	"vi-VN": {
		"components.accountSwitcher": "translation-vi.json",
		"components.footer": "translation-vi.json",
		"components.header": "translation-vi.json",
		"components.pageHeader": "translation-vi.json",
		"components.pivotNav": "translation-vi.json",
		"components.sidenav": "translation-vi.json"
	},
	zh: {
		"components.accountSwitcher": "translation-zh.json",
		"components.footer": "translation-zh.json",
		"components.header": "translation-zh.json",
		"components.pageHeader": "translation-zh.json",
		"components.pivotNav": "translation-zh.json",
		"components.sidenav": "translation-zh.json"
	},
	"zh-CN": {
		"components.accountSwitcher": "translation-zh.json",
		"components.footer": "translation-zh.json",
		"components.header": "translation-zh.json",
		"components.pageHeader": "translation-zh.json",
		"components.pivotNav": "translation-zh.json",
		"components.sidenav": "translation-zh.json"
	},
	"zh-TW": {
		"components.accountSwitcher": "translation-zh.json",
		"components.footer": "translation-zh.json",
		"components.header": "translation-zh.json",
		"components.pageHeader": "translation-zh.json",
		"components.pivotNav": "translation-zh.json",
		"components.sidenav": "translation-zh.json"
	}
};
var arbManifest = {
	endpointMap: endpointMap
};

export { arbManifest as default, endpointMap };
